export type PersonRoleType =
  | 'KeszfizetoKezessegVallalo'
  | 'KezessegVallalo'
  | 'KiemeltBefektInfoFelelos'
  | 'KulonlegesCelGazdEgysegKapcs'
  | 'NemTulajEszkozFelelos'
  | 'ProjectGuarantor'
  | 'ProjectSuretyship'
  | 'ProjectWarranty'
  | 'ProjProfilKez'
  | 'ProjProfilKez2'
  | 'ProjUgyvVez'
  | 'ProjVez'
  | 'SecurityProvider'
  | 'SpecialPurposeContact'
  | 'TsT';

export type LegalEntityRole =
  | 'ProjLeader'
  | 'ProjectGuarantor'
  | 'ProjectSuretyship'
  | 'ProjectWarranty';

export enum FileType {
  projectInitDocument = 0,
  mainImage = 1,
  projectFinancialPlan1y = 2,
  projectFinancialPlan2y = 3,
  projectFinancialPlan3y = 4,
  standardProjectDocument = 5,
  image = 6,
  video = 7,
  document = 8,
  documentCompanyRegistration = 9,
  documentTechnicalDescription = 10,
  documentValuation = 11,
  audio = 12,
  other = 13,
  projectFinancialPlanOther = 14,
  projectOwnerObligation = 15,
  contactAttachment = 16,
  contactConmplainAttachment = 17,
  userLegalEntityRightDocuProfessional = 18,
  userLegalEntityRightDocuPoAAuthorizedPartner = 19,
  userLegalEntityRightDocuPoAAuthorizedRepresentative = 20,
  userLegalEntityRightDocuAuthorizedRepresentativeSignatureSpecimen = 21,
}

export enum ApprovalRepresentationTypes {
  LEGAL_PERSON = 0,
  PROFESSIONAL_CLIENT = 1,
}

export enum RepresentationTypes {
  NATURAL_PERSON = 0,
  LEGAL_PERSON = 1,
  PROFESSIONAL_CLIENT = 2,
}

export enum FinancialAssetConnectionToProjectType {
  ForNonOwnershipAssets = 0,
  NonEquityInstrument = 1,
  EquityInstrument = 2,
  NotPerformingLoan = 3,
  Other = 4,
}

export enum FinancialAssetProjectConnection {
  ForNonOwnershipAssets = 0,
  NonEquityInstrument = 1,
  EquityInstrument = 2,
  NotPerformingLoan = 3,
  Other = 4,
}

export enum FinancialAssetType {
  Loan = 0,
  Share = 1,
  Bond = 2,
  Other = 3,
}
